import { empty as observableEmpty,
  Observable,
  throwError as observableThrowError,
  BehaviorSubject, 
  firstValueFrom,
  of } from 'rxjs'

import { catchError,
  distinctUntilChanged,
  map } from 'rxjs/operators'

import { Injectable } from '@angular/core'

import { ApiService } from './api.service'

import { Setting } from '../_models/setting.model'
import { HttpParams } from '@angular/common/http'

import { MatSnackBar } from '@angular/material/snack-bar';


@Injectable()
export class SettingService {

  private selectedSettingSubject = new BehaviorSubject<Setting>(null)
  public selectedSetting = this.selectedSettingSubject.asObservable().pipe(distinctUntilChanged())
  private selectedSettingLocal: Setting

  constructor (
    private apiService: ApiService,
    private matSnackbar: MatSnackBar
  ) {}

  settingFromData(data: any): Setting {
    // console.log('entryFromData', data, updateSelectedEntry)
    if (!data) return
    if (data['error'] === 'pundit') { console.warn('err: settingFromData-pundit', data['error']); return data }
    let setting = new Setting(data)
    return setting
  }

  shouldUpdateSelectedSetting(setting: Setting, updateSelectedSetting: boolean) {
    if (updateSelectedSetting) return true
    if (!this.selectedSettingLocal) return false
    if (setting.id === this.selectedSettingLocal['id']) return true
    return false
  }

  updateSelectedSetting(setting:Setting): any {
    this.selectedSettingSubject.next(setting)
    this.selectedSettingLocal = setting
    return setting
  }

  getSetting(id: string): Observable<Setting> {
    return this.apiService.get('settings/' + id).pipe(
      catchError(err => this.handleError(err) ),
      map( (res: Setting) => this.settingFromData(res)
    ))
  }

  // ACTUALLY Promise<Pagination<Setting>>
  async getSettings(params:any): Promise<Setting[]> {
    let url = 'settings'

    let routeParams = new HttpParams()
    .set('page', params['page'])
    .set('limit', params['limit'])
    .set('sortBy', params['sortBy'])  // : {}


    return firstValueFrom(this.apiService.get(url, routeParams).pipe(
      catchError(err => this.handleError(err) ),
      map( (res: Setting[]) => {
        res['results'] = res['results'].map(u => new Setting(u)) 
        return res
        }) // this.settingFromData(res)
    ))
  }

  async findSettingBy(params:any = {}): Promise<Setting> {
    let url = 'settings/find'
      return firstValueFrom(this.apiService.post(url, params).pipe(
        catchError(err => this.handleError(err) ),
        map( (res: Setting) => this.settingFromData(res)
    )))
  }

  // Update the setting on the server
  // TODO: DTO instead of raw setting
  update(setting: Setting): Observable<Setting> {
    return this.apiService
      .put('settings/' + setting.id, setting)
      .pipe(map(data => {
        return this.settingFromData(data)
      })
    )
  }

  // TODO: DTO instead of raw setting
  create(setting: Setting): Observable<Setting> {
  // console.log('creating setting?', setting)

  return this.apiService
    .post('settings/create', setting)
    .pipe(
      catchError(err => this.handleError(err) ),
      map(data => {
        console.log('new-setting-data', data)
        return this.settingFromData(data)
      })
    );
  }

  delete(setting: Setting): Observable<Setting> {
  // console.log('TODO: delete setting', setting)
    return this.apiService
      .post('settings/' + setting.id + '/delete')
      .pipe(map(data => {
        // console.log('DELETED', setting)
        return data
        return this.settingFromData(data)
      })
    )
  }

  handleError(err: any) {
    console.warn('ERR: setting.service handled', err)
    let msg = err
    if (err.message) msg = err.message
    this.matSnackbar.open(`ERROR: ${msg}`, 'close', { duration: 5000 });
    if (!err) return Promise.reject()
    return observableThrowError(err)
  }
}
